import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useGlobal } from "reactn";

export const Dropdown = ({
  options,
  handleChange,
  handleInput,
  SearchFieldText,
  NoHits,
  handleOverlay,
  Heading,
}) => {
  const [theme] = useGlobal("theme");

  const [showDropdown, setShowDropdown] = useState(false);
  let handleInputChange = (inputValue) => {
    handleInput(inputValue);

    if (inputValue.length > 1 && !showDropdown) setShowDropdown(true);
    else if (inputValue.length < 2 && showDropdown) setShowDropdown(false);
  };
  const customStyles = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      color: isSelected ? "white" : "black",
      padding: 15,
      cursor: "pointer",
      background: isSelected ? theme.colors.gradient : "white",
      border: isFocused ? "1px solid #515151" : "none",
      boxShadow: isFocused ? "0px 0px -10px #515151" : "none",
      "&:hover": {
        background: isSelected ? theme.colors.primaryDark : "#f7f7f7",
      },
    }),

    control: (provided, {isFocused}) => ({
      ...provided,
      width: "auto",
      borderRadius: 50,
      padding: "7px 10px",
      border: "1px solid #515151",
      borderColor: "#949494",
      cursor: "text",
      boxShadow: "none",
      outline: isFocused ? "#515151 solid 2px " : "0",
      outlineOffset: "5px",
      "&:hover": {
        borderColor: theme.colors.primary,
      },
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      fontFamily: theme.font,
    }),
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    placeholder: (provided) => ({
      ...provided,
      fontFamily: theme.font,
      color: "black",
    }),
    clearIndicator: (provided, state) => ({
      ...provided,
      paddingTop: 0,
      paddingBottom: 0,
      cursor: "pointer",
    }),
    dropdownIndicator: () => ({
      display: "none",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 500,
      fontFamily: theme.font,
    }),
    indicatorSeparator: () => ({
      cursor: "pointer",
    }),
    IndicatorsContainer: () => ({
      marginRight: "80px",
      cursor: "pointer",
    }),
  };

  return (
    <Select
      aria-label={Heading || 'Select'}
      isClearable={true}
      isSearchable={true}
      openMenuOnFocus={true}
      onFocus={() => handleOverlay()}
      styles={customStyles}
      placeholder={SearchFieldText}
      onInputChange={handleInputChange}
      options={options}
      noOptionsMessage={() => (showDropdown ? NoHits : null)}
      onChange={(item) => handleChange(item)}
    />
  );
};
